import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import { TrabajadorService } from '../../../services/trabajador.service';
import { LoginService } from '../../../services/login.service';
export class PronexoWorkersModalComponent {
    constructor(trabajadorService, loginService) {
        this.trabajadorService = trabajadorService;
        this.loginService = loginService;
        this.workersIdSelected = [];
        this.workersSelected = [];
        this.workersChange = new EventEmitter();
        this.planCapacitacion = null;
        this.workers = [];
        this.columns = [
            'Rut Trabajador',
            'Nombre',
            'Apellido Paterno',
            'Apellido Materno',
            'Rut Contratista'
        ];
        this.rows = [];
        this.rowsB = [];
        this.page = 0;
        this.pageSize = 10;
        this.totalAmmount = 0;
        this.loading = false;
        this.sizeOptions = [
            { label: '10 por página', value: 10 },
            { label: '20 por página', value: 20 },
            { label: '50 por página', value: 50 }
        ];
        this.loginData = JSON.parse(sessionStorage.getItem('loginData'));
        /*   rutContratista: string; */
        this.rutContratista = this.loginData.usertableentity.rutContratista;
        this.rolId = '';
    }
    ngOnInit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.loginService.obtenerPermisosMenu('planificacion').then((response) => {
                this.rolId = response.data.rolId;
            });
            this.workersIdSelected = JSON.parse(JSON.stringify(this.workersIdSelected));
            this.workersSelected = JSON.parse(JSON.stringify(this.workersSelected));
            if (this.planCapacitacion == null) {
                this.fetchTrabajadores();
                this.fetchAmmount();
            }
            else {
                this.fetchTrabajadoresEmpresa();
                this.fetchAmmountEmpresa();
            }
            this.searchWorker();
        });
    }
    fetchTrabajadores() {
        this.loading = true;
        this.trabajadorService.list(this.page, this.pageSize, Number(this.rolId))
            .then(workers => {
            this.workers = workers;
            this.rows = workers.map(worker => this.buildRow(worker));
            this.rowsB = this.rows;
            this.loading = false;
        })
            .catch(error => {
            console.error(error);
            this.loading = false;
        });
    }
    fetchTrabajadoresEmpresa() {
        this.loading = true;
        this.trabajadorService.listEmpresa(this.page, this.pageSize, this.planCapacitacion, Number(this.rolId))
            .then(workers => {
            this.workers = workers;
            this.rows = workers.map(worker => this.buildRow(worker));
            this.rowsB = this.rows;
            this.loading = false;
        })
            .catch(error => {
            console.error(error);
            this.loading = false;
        });
    }
    fetchAmmount() {
        this.trabajadorService.getTotalAmmount(Number(this.rolId))
            .then(ammount => this.totalAmmount = ammount)
            .catch(error => console.error(error));
    }
    fetchAmmountEmpresa() {
        this.trabajadorService.getTotalAmmountEmpresa(this.planCapacitacion, Number(this.rolId))
            .then(ammount => this.totalAmmount = ammount)
            .catch(error => console.error(error));
    }
    buildRow(worker) {
        /* this.prueba = worker.rutTrabajador; */
        return {
            id: worker.rutTrabajador,
            prueba: this.prueba = worker.rutTrabajador,
            worker,
            cells: [
                { class: 'td-centered', tooltip: false, content: worker.rutTrabajador },
                { class: 'td-centered', tooltip: false, content: worker.nombreTrabajador },
                { class: 'td-centered', tooltip: false, content: worker.apellidoPaterno },
                { class: 'td-centered', tooltip: false, content: worker.apellidoMaterno },
                { class: 'td-centered', tooltip: false, content: worker.rutContratista },
            ]
        };
    }
    onChangePage(page) {
        this.page = page;
        if (this.planCapacitacion == null) {
            this.fetchTrabajadores();
            this.fetchAmmount();
        }
        else {
            this.fetchTrabajadoresEmpresa();
            this.fetchAmmountEmpresa();
        }
        //this.fetchTrabajadores();
    }
    onChangeSize(size) {
        this.pageSize = size;
        if (this.planCapacitacion == null) {
            this.fetchTrabajadores();
            this.fetchAmmount();
        }
        else {
            this.fetchTrabajadoresEmpresa();
            this.fetchAmmountEmpresa();
        }
        //this.fetchTrabajadores();
    }
    changeWorkerSearch(query) {
        this.workerSearch = this.formatRut(query);
    }
    searchWorker() {
        this.loading = true;
        this.rows = [];
        this.totalAmmount = 0;
        this.page = 0;
        this.trabajadorService.search(this.workerSearch)
            .then(worker => {
            if (worker) {
                this.prueba = worker.rutTrabajador;
                if (worker != null && (worker.rutTrabajador === this.prueba) && (this.rutContratista === worker.rutContratista) && this.rolId != '1') {
                    this.loading = true;
                    this.rows = [this.buildRow(worker)];
                }
                else if (worker != null && (worker.rutTrabajador === this.prueba) && this.rolId == '1') {
                    this.loading = true;
                    this.rows = [this.buildRow(worker)];
                }
                else {
                    console.log("RUT NO TIENE RELACION CON CONTRATISTA ACTIVO");
                    this.rows = [];
                    this.loading = false;
                }
            }
        })
            .catch(error => {
            console.error(error);
            this.loading = false;
        });
    }
    cleanSearch() {
        this.page = 0;
        if (this.planCapacitacion == null) {
            this.fetchTrabajadores();
            this.fetchAmmount();
        }
        else {
            this.fetchTrabajadoresEmpresa();
            this.fetchAmmountEmpresa();
        }
    }
    changeSearch(e) {
        let valor = e.target.value;
        if (this.rows.length > 0) {
            if (valor.length > 1) {
                let word = valor.toLowerCase();
                this.rows = this.rowsB.filter((item) => {
                    let str = item.worker.rutTrabajador + item.worker.nombreTrabajador + item.worker.apellidoPaterno + item.worker.apellidoMaterno + item.worker.rutContratista;
                    str = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                    return str.toLowerCase().indexOf(word) > -1;
                });
            }
        }
        if (valor.length < 2) {
            this.rows = this.rowsB;
        }
    }
    isIconActive(icon, id) {
        if (icon === 'add') {
            return !this.workersIdSelected.includes(id);
        }
        return this.workersIdSelected.includes(id);
    }
    addWorker(worker) {
        if (this.isIconActive('add', worker.rutTrabajador)) {
            this.workersIdSelected.push(worker.rutTrabajador);
            this.workersSelected.push(worker);
        }
    }
    removeWorker(worker) {
        if (this.isIconActive('remove', worker.rutTrabajador)) {
            const idIndex = this.workersIdSelected.findIndex(id => id === worker.rutTrabajador);
            const workerIndex = this.workersSelected.findIndex(workerToAdd => workerToAdd.rutTrabajador === worker.rutTrabajador);
            this.workersIdSelected.splice(idIndex, 1);
            this.workersSelected.splice(workerIndex, 1);
        }
    }
    onAccept() {
        this.workersChange.emit({ workersIdSelected: this.workersIdSelected, workersSelected: this.workersSelected });
        this.modal.dismiss('accept');
    }
    formatRut(paramrut) {
        const actual = (paramrut) ? paramrut.toString().replace(/^0+/, "") : "";
        const withoutPoints = actual.replace(/\./g, "") || "";
        const actualClean = withoutPoints.replace(/-/g, "") || "";
        if (actualClean !== "" && actualClean.length > 1) {
            const start = actualClean.substring(0, actualClean.length - 1);
            let rut = '';
            let i = 0;
            let j = 1;
            for (i = start.length - 1; i >= 0; i--) { // eslint-disable-line no-plusplus
                const letter = start.charAt(i);
                rut = letter + rut;
                if (j % 3 === 0 && j <= start.length - 1) {
                    rut = `.${rut}`;
                }
                j++; // eslint-disable-line no-plusplus
            }
            const dv = actualClean.substring(actualClean.length - 1);
            rut = `${rut}-${dv}`;
            return rut.toUpperCase();
        }
        return actualClean.toUpperCase();
    }
}
